import React from "react";
import { PawPrint } from "lucide-react";
import { assetUrl } from "@/lib/api";

export function PetAvatar({ pet, url, name, size = 48, ring = false, testid }) {
  const src = url !== undefined ? url : pet?.photo_url;
  const label = name || pet?.name || "?";
  const full = src?.startsWith("/api") ? assetUrl(src) : src;
  return (
    <span data-testid={testid} className={`shrink-0 rounded-full overflow-hidden bg-[#FFF7E6] grid place-items-center ${ring ? "ring-4 ring-white shadow-md" : ""}`}
      style={{ width: size, height: size }}>
      {full ? <img src={full} alt={label} className="h-full w-full object-cover" loading="lazy" />
        : <span className="font-heading font-bold text-[#D97706]" style={{ fontSize: size * 0.4 }}>{label[0]?.toUpperCase() || <PawPrint />}</span>}
    </span>
  );
}
